import z from "zod";
import { USCheckboxFilterSchema } from "./base-schema";
import { USCheckboxValueOptionsSchema } from "./us-checkbox-options";

const FLUMTypeKeys = [
  "conservation",
  "commercial_core",
  "downtown_urban_core",
  "federal",
  "commercial_general",
  "mixed_use_general",
  "industrial",
  "institutional",
  "industrial_light",
  "mixed_use",
  "residential_multi_family",
  "native_american_lands",
  "commercial_neighborhood",
  "neighborhood_activity_center",
  "commercial_office",
  "planned",
  "recreation",
  "commercial_retail",
  "mixed_use_rural",
  "residential_single_family",
  "commercial_special",
  "special",
  "special_planning_area",
  "transportation_utilities",
  "residential_two_family",
  "unknown",
  "water",
] as const;

const FLUMOptionValuesSchema = USCheckboxValueOptionsSchema(FLUMTypeKeys);

export const FLUMSchema = USCheckboxFilterSchema.extend({
  id: z.literal("flum-id"),
  values: z.array(FLUMOptionValuesSchema),
});
